import React from 'react';

const PermissionList = ({ permissions, rolePermissions, onToggle }) => (
  <div className="max-h-96 overflow-y-auto border dark:border-gray-600 rounded-lg p-4 bg-white dark:bg-gray-800">
    {permissions.map((perm) => (
      <div key={perm.id} className="flex items-center mb-2">
        <input
          type="checkbox"
          id={`perm-${perm.id}`}
          checked={rolePermissions.includes(perm.id)}
          onChange={() => onToggle(perm.id)}
          className="mr-2 w-4 h-4 text-primary-600 dark:text-primary-400 bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded focus:ring-primary-500 dark:focus:ring-primary-400"
        />
        <label htmlFor={`perm-${perm.id}`} className="text-gray-700 dark:text-gray-300 cursor-pointer">
          <span className="font-medium">{perm.name}</span> <span className="text-gray-400 dark:text-gray-500">- {perm.description}</span>
        </label>
      </div>
    ))}
  </div>
);

export default PermissionList;
